import { RouterProvider } from "react-router-dom";
import { router } from "./router/routerForLazy";

export default function App() {
  return <RouterProvider router={router} />;
}
